import React, { useState, useCallback, useEffect } from 'react'
import { Select, Checkbox } from '@duik/it'
import MainContainer from '../UI/MainContainer'
import TableContainer from '../UI/TableContainer'
import TableSection from '../UI/TableSection'
import TableHeader from '../UI/TableHeader'
import LibraryAddIcon from '@material-ui/icons/LibraryAddRounded'
import moment from 'moment'
import TableRow from '../UI/TableRow'
import SignOnOffModal from './SignOnOffModal'
import SignOnOffMultiModal from './SignOnOffMultiModal'
import ToolTip from '../UI/ToolTip'
import { getActiveNow, updateSignOnOffTimes } from './Store/actions'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import TableTopSection from 'UI/TableTopSection'

const ActiveNow = props => {
  const [loadView, setLoadView] = useState('trucks')
  const [checkedItems, setCheckedItems] = useState([])
  const [signOnSignOffModal, setSignOnSignOffModal] = useState(false)
  const [signOnSignOffMultiModal, setSignOnSignOffMultiModal] = useState(false)
  const [editDetail, setEditDetail] = useState()

  const newDrivers = [
    ...new Set(
      props.activeNow.activeData.reduce((acc, cur) => {
        if (cur.driverLicencePlate) {
          acc.push(cur.driverLicencePlate)
        }
        return acc
      }, [])
    )
  ]

  const handleCheckBox = id => {
    const checked = checkedItems.findIndex(item => item === id)
    if (checked === -1) {
      setCheckedItems([...checkedItems, id])
    } else {
      checkedItems.splice(checked, 1)
      setCheckedItems([...checkedItems])
    }
  }

  const handleSignOnSignOffModal = _id => {
    if (_id) {
      const detail = props.activeNow.signOnOffData.find(item => item._id === _id)
      setEditDetail(detail)
    }
    setSignOnSignOffModal(!signOnSignOffModal)
  }

  const handleSignOnSignOffMultiModal = _id => {
    if (_id) {
      const detail = props.activeNow.signOnOffData.find(item => item._id === _id)
      setEditDetail(detail)
    }
    setSignOnSignOffMultiModal(!signOnSignOffMultiModal)
  }

  const handleEditTime = (signOnTime, signOffTime, _id = null) => {
    const body = { signOnTime, signOffTime }
    const ids = _id ? _id : checkedItems.toString()

    props.updateSignOnOffTimes(ids, body)
    setSignOnSignOffModal(false)
    setCheckedItems([])
  }

  useEffect(() => {
    props.getActiveNow(true)
  }, []) //eslint-disable-line

  const HeaderSubTitle = useCallback(() => {
    if (checkedItems.length > 0) {
      return (
        <>
          <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
            {checkedItems.length} trucks selected
          </p>
          <div className="tooltip" style={{ margin: 0 }}>
            <LibraryAddIcon
              className="actionsIcon"
              onClick={() =>
                checkedItems.length > 1
                  ? handleSignOnSignOffMultiModal(checkedItems[0])
                  : handleSignOnSignOffModal(checkedItems[0])
              }
            />
            <span className="tooltiptext">Sign On</span>
          </div>
        </>
      )
    }
    return (
      <p style={{ fontSize: '0.875rem', color: '#9EA0A5', padding: '0 15px' }}>
        {loadView === 'trucks' && props.activeNow.drivers.length + newDrivers.length}
        {loadView === 'projects' && props.activeNow.projects.length}
        {loadView === 'hauls' && props.activeNow.hauls.length} {loadView} as of{' '}
        {moment(props.activeNow.updatedDt).format('HH:mm')}
      </p>
    )
  }, [
    props.activeNow.loading,
    checkedItems,
    loadView,
    props.activeNow.signOnOffData,
    props.activeNow.drivers
  ])

  return (
    <MainContainer>
      <TableContainer>
        <TableTopSection
          title="Active Now"
          loading={props.activeNow.loading}
          additionalElement={
            <div
              style={{
                display: 'flex',
                marginLeft: 'auto',
                alignItems: 'center'
              }}
            >
              <Select
                className="activeViewSelect"
                activeOption={{
                  value: 'trucks',
                  label: (
                    <span className="haulViewTitle">
                      View:
                      <span className="haulViewType">
                        {loadView.charAt(0).toUpperCase() + loadView.slice(1)}
                      </span>
                    </span>
                  )
                }}
                options={[
                  { value: 'trucks', label: 'Trucks' },
                  { value: 'projects', label: 'Projects' },
                  {
                    value: 'hauls',
                    label: 'Hauls'
                  }
                ]}
                onOptionClick={e => setLoadView(e.value)}
                position="bottomRight"
              />
            </div>
          }
        />

        {!props.activeNow.loading &&
          props.activeNow.activeData &&
          props.activeNow.signOnOffData &&
          loadView === 'trucks' && (
            <TableSection>
              <thead>
                <tr>
                  {[
                    '',
                    '',
                    'TRUCK ID',
                    'LICENCE PLATE',
                    'DRIVER',
                    'LOADS',
                    'SIGN ON',
                    'SIGN OFF',
                    ''
                  ].map((item, i) => (
                    <TableHeader title={item} key={i} />
                  ))}
                </tr>
              </thead>
              <tbody>
                {props.activeNow.signOnOffData.map((item, i) => {
                  let loads = props.activeNow.activeData.filter(
                    data => data.driverId === item.driverId && data.haulId === item.haulId
                  ).length
                  let projectName = ''
                  let haulId = ''

                  if (
                    i !== 0 &&
                    item.projectName === props.activeNow.signOnOffData[i - 1].projectName &&
                    item.haulId === props.activeNow.signOnOffData[i - 1].haulId
                  ) {
                    projectName = ''
                    haulId = ''
                  } else {
                    projectName = item.projectName
                    haulId = item.haulId
                  }

                  return (
                    <TableRow key={item._id}>
                      <td
                        onClick={() => props.history.push(`/app/hauls/${haulId}/loads/${haulId}`)}
                      >
                        <span style={{ fontSize: '14px', fontWeight: 500 }}>{projectName}</span>
                        <br />
                        <span style={{ fontSize: '12px', color: '#9EA0A5' }}>{haulId}</span>
                      </td>
                      <td>
                        <Checkbox
                          onChange={e => handleCheckBox(item._id)}
                          checked={checkedItems.indexOf(item._id) === -1 ? false : true}
                        />
                      </td>
                      <td>
                        <span style={{ fontSize: '14px', fontWeight: 500 }}>{item.truckId}</span>
                        <br />
                        <span style={{ fontSize: '12px', color: '#9EA0A5' }}>{item.truckType}</span>
                      </td>
                      <td style={{ fontSize: '14px', fontWeight: 500 }}>{item.licencePlate}</td>
                      <td>
                        <span style={{ fontSize: '14px', fontWeight: 500 }}>
                          {item.firstName} {item.lastName}
                        </span>
                        <br />
                        <span style={{ fontSize: '12px', color: '#9EA0A5' }}>
                          {item.companyName}
                        </span>
                      </td>
                      <td style={{ fontSize: '14px', fontWeight: 500 }}>{loads}</td>

                      <td style={{ fontSize: '14px', fontWeight: 500 }}>
                        {item.signOnTime && item.signOnTime.length > 0
                          ? moment(item.signOnTime).format('HH:mm')
                          : 'HH:MM'}
                      </td>
                      <td style={{ fontSize: '14px', fontWeight: 500 }}>
                        {item.signOffTime && item.signOffTime.length > 0
                          ? moment(item.signOffTime).format('HH:mm')
                          : 'HH:MM'}
                      </td>
                      <td style={{ textAlign: 'right' }}>
                        <ToolTip title="Sign On">
                          <LibraryAddIcon
                            className="actionsIcon"
                            onClick={() => handleSignOnSignOffModal(item._id)}
                          />
                        </ToolTip>
                      </td>
                    </TableRow>
                  )
                })}

                {newDrivers.map((item, i) => {
                  const load = props.activeNow.activeData.find(
                    active => active.driverLicencePlate === item
                  )

                  const loads = props.activeNow.activeData.filter(
                    data => data.driverLicencePlate === item
                  ).length
                  const truck = props.activeNow.activeData.find(
                    active => active.driverLicencePlate === item
                  )

                  const projectName = props.hauls.find(item => item.haulId === load.haulId).project
                    .projectName
                  const haulId = truck.haulId

                  return (
                    <TableRow key={item._id}>
                      <td
                        onClick={() => props.history.push(`/app/hauls/${haulId}/loads/${haulId}`)}
                      >
                        <span style={{ fontSize: '14px', fontWeight: 500 }}>{projectName}</span>
                        <br />
                        <span style={{ fontSize: '12px', color: '#9EA0A5' }}>{haulId}</span>
                      </td>
                      <td>
                        <Checkbox
                          // onChange={e => handleCheckBox(item._id)}
                          // checked={checkedItems.indexOf(item._id) === -1 ? false : true}
                          disabled
                        />
                      </td>
                      <td>
                        <span style={{ fontSize: '14px', fontWeight: 500 }}>
                          {item.truckId ? item.truckId : '-'}
                        </span>
                        <br />
                        <span style={{ fontSize: '12px', color: '#9EA0A5' }}>-</span>
                      </td>
                      <td style={{ fontSize: '14px', fontWeight: 500 }}>{item}</td>
                      <td>
                        <span style={{ fontSize: '14px', fontWeight: 500 }}>-</span>
                        <br />
                        <span style={{ fontSize: '12px', color: '#9EA0A5' }}>-</span>
                      </td>
                      <td style={{ fontSize: '14px', fontWeight: 500 }}>{loads}</td>

                      <td style={{ fontSize: '14px', fontWeight: 500 }}>-</td>
                      <td style={{ fontSize: '14px', fontWeight: 500 }}>-</td>
                      {/* <td style={{ textAlign: 'right' }}>
                        <ToolTip title="Sign On">
                          <LibraryAddIcon className="actionsIcon" onClick={() => undefined} />
                        </ToolTip>
                      </td> */}
                    </TableRow>
                  )
                })}
              </tbody>
            </TableSection>
          )}

        {!props.activeNow.loading && loadView === 'projects' && (
          <TableSection>
            <thead>
              <tr>
                {['', 'TRUCKS', 'LOADS'].map(item => (
                  <TableHeader title={item} />
                ))}
              </tr>
            </thead>
            <tbody>
              {props.activeNow.projects.map((item, i) => {
                let trucks = props.activeNow.signOnOffData.filter(data => data.projectName === item)
                  .length
                let loads = props.activeNow.activeData.filter(
                  data => data.haul.project.projectName === item
                ).length
                return (
                  <TableRow>
                    <td style={{ width: '20%', fontWeight: '500' }}>{item}</td>
                    <td style={{ width: '10%', fontWeight: '500' }}>{trucks}</td>
                    <td style={{ fontWeight: '500' }}>{loads}</td>
                  </TableRow>
                )
              })}
            </tbody>
          </TableSection>
        )}

        {!props.activeNow.loading && loadView === 'hauls' && (
          <TableSection>
            <thead>
              <tr>
                {['', 'TRUCKS', 'LOADS'].map(item => (
                  <TableHeader title={item} />
                ))}
              </tr>
            </thead>
            <tbody>
              {props.activeNow.hauls.map((item, i) => {
                let trucks = props.activeNow.signOnOffData.filter(data => data.haulId === item)
                  .length
                let loads = props.activeNow.activeData.filter(data => data.haulId === item).length
                return (
                  <TableRow>
                    <td style={{ width: '20%', fontWeight: '500' }}>{item}</td>
                    <td style={{ width: '10%', fontWeight: '500' }}>{trucks}</td>
                    <td style={{ fontWeight: '500' }}>{loads}</td>
                  </TableRow>
                )
              })}
            </tbody>
          </TableSection>
        )}
      </TableContainer>
      {signOnSignOffModal && (
        <SignOnOffModal
          handleClose={handleSignOnSignOffModal}
          handleEditTime={handleEditTime}
          editDetail={editDetail}
          checkedItems={checkedItems}
        />
      )}
      {signOnSignOffMultiModal && (
        <SignOnOffMultiModal
          handleClose={handleSignOnSignOffMultiModal}
          handleEditTime={handleEditTime}
          editDetail={editDetail}
          checkedItems={checkedItems}
        />
      )}
    </MainContainer>
  )
}

const mapStateToProps = state => {
  return {
    activeNow: state.activeNow,
    hauls: state.hauls.haulList
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ getActiveNow, updateSignOnOffTimes }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(ActiveNow)
